cv.TableView = Marionette.CompositeView.extend({
  template : cv.Templates['table/list'],
  childViewContainer: 'tbody',
  getChildView: function(){
    return this.options.row_view;
  },
  getEmptyView: function(){
    return cv.TableRowEmptyView;
  },

  events: {
  },

  childEvents: {
    'show' : function() {
    },
    'render' : function() {
    }
  },

  collectionEvents: {
    'sync' : 'collectionSync',
    'reset' : 'collectionReset',
    'request' : 'collectionRequest'
  },

  childViewOptions: function(model, index) {
    // do some calculations based on the model
    return {
      row_empty_data : this.options.row_empty_data
    }
  },

  initialize: function(options){
    this.mergeOptions(options, this.options);

    console.log('TableView initialized');
  },

  collectionSync: function(collection){
    // Fire imgix
    if(this.$('.imgix-fluid').length > 0){
      imgix.fluid(this.$el.get(0), {
        updateOnResizeDown: false,
        pixelStep: 5,
        autoInsertCSSBestPractices: true
      });
    }
  },

  collectionReset: function(collection){
    if(collection.num_records > 0){
      this.$('thead').show();
    }
  },

  collectionRequest: function(collection){
    this.$('thead').hide();
  },

  isEmpty: function(collection){
    if(collection.num_records > 0){
      return false;
    }
    if(collection.num_records == 0 || _.isUndefined(collection.num_records)){
      return true;
    }
  },

  attachHtml: function(collectionView, childView, index){
    if (collectionView.isBuffering) {
      // buffering happens on reset events and initial renders
      // in order to reduce the number of inserts into the
      // document, which are expensive.
      collectionView._bufferedChildren.splice(index, 0, childView);
    }else {
      // If we've already rendered the main collection, append
      // the new child into the correct order if we need to. Otherwise
      // append to the end.
      if (!collectionView._insertBefore(childView, index)){
        collectionView._insertAfter(childView);
      }
    }
  },

  templateHelpers: function(){
    return {
    }
  },

  onBeforeShow: function(){
  },

  onShow: function(){
    this.collection.fetch({
      reset: true
    });

    if(_.has(this.options, 'row_heading_tpl')){
      this.$('thead').html(cv.Templates[this.options.row_heading_tpl]());
    }
  },

  onDestroy: function(){
  }
});
